import { render } from "./ImportDetailSettingsTab.vue?vue&type=template&id=3ba26271&scoped=true"
import script from "./ImportDetailSettingsTab.vue?vue&type=script&lang=js"
export * from "./ImportDetailSettingsTab.vue?vue&type=script&lang=js"

import "./ImportDetailSettingsTab.vue?vue&type=style&index=0&id=3ba26271&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba26271"]])

export default __exports__